<template>

  <div class="modal fade" id="AddActiviteModal" tabindex="-1" role="dialog" ref="addActiviteModalRef"
    aria-labelledby="tooltipmodal" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="Activite">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">{{ title }}</h4>
          <button class="btn-close py-0" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <Form ref="activiteForm" @submit="addActivite" :validation-schema="activiteSchema">
            <div class="row">


              <div class="col-md-12 mb-3">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Libelle <span class="text-danger">*</span>
                  </label>
                  <Field name="libelle" type="text" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Entrer le libelle" />
                  <ErrorMessage name="libelle" class="text-danger" />
                </div>
              </div>

              <div class="col-md-12 mb-3">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Categorie d'activité<span class="text-danger">*</span>
                  </label>
                  <Field name="categorieActivite" type="text" v-slot="{ field }">
                    <Multiselect v-model="field.value" v-bind="field" :options="categorieActiviteOptions"
                      :preserve-search="true" :multiple="false" :searchable="true"
                      placeholder="Sélectionner la categorie activite" label="label" track-by="label" />
                  </Field>
                  <ErrorMessage name="categorieActivite" class="text-danger" />
                </div>
              </div>


              <button class="btn btn-primary" type="submit">
                {{ btntext }}
              </button>
            </div>
          </Form>
        </div>

      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { ref, watch, onMounted } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import * as Yup from 'yup';
import ApiService from '@/services/ApiService';
import { error, hideModal, success } from '@/utils/utils';
//import { Activite } from '@/models/Activite';
import { useRouter } from 'vue-router';
import Multiselect from '@vueform/multiselect';


export default {
  name: "AddActiviteModal",
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect
  },
  props: {
    id: {
      type: Number,
      required: true,
      default: 0
    },
  },
  emits: ["refreshActivites", 'openmodal'],

  setup: (props: any, { emit }: { emit: (event: string, payload?: any) => void }) => {

    const loading = ref<boolean>(false);
    const activiteSchema = Yup.object().shape({
      libelle: Yup.string().required('Le libelle est obligatoire'),
      categorieActivite: Yup.string().required('La categorie est obligatoire'),

    });

    onMounted(() => {
      getAllCategorieActivites();
    });
    const categorieActivite = ref();
    const categorieActiviteOptions = ref();
    const activitenew = ref(props.id);
    const activiteForm = ref<any | null>(null);
    const addActiviteModalRef = ref<null | HTMLElement>(null);
    let activites = ref<Array<any>>([]);
    const title = ref('Ajouter une activité ');
    const btntext = ref('Ajouter');
    const isupdate = ref(false);
    const router = useRouter();

    watch(() => props.id, (newValue) => {
      if (newValue != 0) {
        getActivite(newValue);
        isupdate.value = true;
      }
      btnTitle();
    });

    /*  const getActivite = async (id: number) => {
        return ApiService.get("/activites/"+id)
        .then(({ data }) => {
          activiteForm.value?.setFieldValue("id",data.data.id);
          activiteForm.value?.setFieldValue("libelle",data.data.libelle);
          activiteForm.value?.setFieldValue("categorie", data.data.categorie.id);
          emit('openmodal', addActiviteModalRef.value);
        })
        .catch(({ response }) => {
          error(response.data.message)
        });
      }*/


    const getActivite = async (id: number) => {
      return ApiService.get("/activites/" + id)
        .then(({ data }) => {
          console.log("Données récupérées: ", data);
          const donnees = data.data;
          for (const key in donnees) {
            activiteForm.value?.setFieldValue(
              key,
              typeof donnees[key] === "object" && donnees[key] !== null
                ? donnees[key].id
                : donnees[key]
            );
          }

          if (donnees.categorieActivite) {
            activiteForm.value?.setFieldValue(
              "categorieActivite",
              donnees.categorieActivite.id
            );
          }

          emit("openmodal", addActiviteModalRef.value);
        })
        .catch(({ response }) => {
          console.error("Erreur lors de la récupération: ", response);
          error(response.data.message);
        });
    };


    const getAllCategorieActivites = async () => {
      try {
        const response = await ApiService.get('/all/categorieActivites');
        const categorieActivitesData = response.data.data.data;
        console.log('Data CATEGORIE ===>', categorieActivitesData)
        categorieActiviteOptions.value = categorieActivitesData.map((categorieActivite) => ({
          value: categorieActivite.id,
          label: categorieActivite.libelle,
        }));
      }
      catch (error) {
        //error(response.data.message)
      }
    }

    const btnTitle = async () => {
      if (isupdate.value) {
        title.value = "Modifier activite";
        btntext.value = "Modifier";
      } else {
        title.value = "Ajouter une activite ";
        btntext.value = "Ajouter";
      }
    }

    const addActivite = async (values: any, { resetForm }: { resetForm: () => void }) => {
      //values = values as Activite;
      loading.value = false;
      if (isupdate.value) {
        ApiService.put(`/activites/${values.id}`, values)
          .then(({ data }) => {
            if (data.code == 200) {
              success(data.message);
              resetForm();
              hideModal(addActiviteModalRef.value);
              isupdate.value = false;
              btnTitle();
              emit("refreshActivites");
              router.push('/liste-activite');
            }
          }).catch(({ response }) => {
            error(response.data.message);
          });
      } else {
        ApiService.post("/activites", values)
          .then(({ data }) => {
            if (data.code == 201) {
              success(data.message)
              resetForm();
              hideModal(addActiviteModalRef.value);
              emit("refreshActivites");

            }
          }).catch(({ response }) => {
            error(response.data.message);
          });
      }
    };

    const resetValue = () => {
      const formFields = document.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>('input, textarea');
      isupdate.value = false;
      formFields.forEach(field => {
        field.value = '';
      });
      btnTitle()
    };

    return {
      activites, title, btntext, resetValue, activiteSchema,
      addActivite, activiteForm, addActiviteModalRef, activitenew,
      categorieActivite,
      categorieActiviteOptions,
    };
  },
};
</script>@/models/Activite